<template>
    <div class="CollapsedContentLayout" :class="{ mobileCenterLayout }">
        <MyAvatar class="icon" />
        <div class="textBox">
            <div class="title">
                {{ title }}
            </div>
            <div class="subtitle">
                {{ subtitle }}
            </div>
        </div>
        <div class="break" />
        <PlainButton class="button" :color="color" @click="$emit('click')">
            {{ buttonLabel }}
        </PlainButton>
    </div>
</template>

<script>
import MyAvatar from '@/components/MyAvatar';
import PlainButton from './PlainButton';

export default {
    components: { MyAvatar, PlainButton },
    props: {
        title: {
            type: String
        },
        subtitle: {
            type: String
        },
        buttonLabel: {
            type: String
        },
        color: {
            type: String,
            default: '#5DB1CF'
        },
        mobileCenterLayout: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.CollapsedContentLayout {
    display: flex;
    align-items: center;
    padding: 1em;
}
.icon {
    $borderWidth: 0.4em;
    $size: 2.7em + $borderWidth * 2;
    width: $size;
    height: $size;
    margin-right: 1em;
    flex-shrink: 0;
    box-shadow: 0 0 0 #{$borderWidth} rgba(black, 0.05);
}
.textBox {
    flex: 1;
}
.button {
    margin-left: 1em;
}

.title {
    font-weight: 600;
    font-size: 120%;
}
.subtitle {
    margin-top: 0.3em;
    line-height: 1.4em;
}

@include media('>=mobile') {
}

@include media('<mobile') {
    .CollapsedContentLayout {
        flex-wrap: wrap;
    }
    .break {
        width: 100%;
        height: 0.5em;
    }
    .button {
        margin-left: auto;
        margin-right: auto;
    }

    .CollapsedContentLayout.mobileCenterLayout {
        flex-direction: column;

        .subtitle {
            text-align: center;
        }
        .button {
            margin-top: 1em;
        }
    }
}
</style>
